import React from 'react';
import i18next from 'i18next';
import cn from 'classnames';
import { numberWithSpaces } from '../../../utils';

class GameCard extends React.Component {
  onClick = () => {
    this.props.onClick(this.props.name);
  };

  render() {
    const { name, public: fullName, online, withdraw, status } = this.props;

    return (
      <div
        className={cn('sl-game-card', { 'sl-game-card--online': status })}
        onClick={this.onClick}
      >
        <img src={`/img/slots/${name}.png`} alt={fullName} />
        <span className="sl-game-card__name">{fullName}</span>

        <div className="sl-game-card__stats">
          <div>
            <span className="sl-game-card__stats-name">
              {i18next.t('slots.online')}
            </span>
            <span className="sl-game-card__stats-value">{online}</span>
          </div>
          <div>
            <span className="sl-game-card__stats-name">
              {i18next.t('slots.payout')}
            </span>
            <span className="sl-game-card__stats-value">
              {numberWithSpaces(withdraw)} <span className="yellow">CASH</span>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default GameCard;



// WEBPACK FOOTER //
// ./app/components/SlotsGame/GameCard/GameCard.jsx